module.exports = __webpack_public_path__ + "img/title-4.43b67a64.png";